import * as React from 'react';
import { View, Text, StyleSheet, Image } from 'react-native';
import { PropsStackModelTri } from '../types';
import { themePattern } from '../constants/pattern';
import { aminoacidos } from '../assets/aminoacidos';
import ModelTriAtom from '../components/Trid/ModelTriAtom';

console.log(aminoacidos(1).info[0]);

// Todas as imagens dos aminoacidos
const ala = require('./../assets/models/ala.gif');
const arg = require('./../assets/models/arg.gif');
const asn = require('./../assets/models/asn.gif');
const asp = require('./../assets/models/asp.gif');
const cys = require('./../assets/models/cys.gif');
const gln = require('./../assets/models/gln.gif');
const glu = require('./../assets/models/glu.gif');
const gly = require('./../assets/models/gly.gif');
const his = require('./../assets/models/his.gif');
const ile = require('./../assets/models/ile.gif');
const leu = require('./../assets/models/leu.gif');
const lys = require('./../assets/models/lys.gif');
const met = require('./../assets/models/met.gif');
const phe = require('./../assets/models/phe.gif');
const pro = require('./../assets/models/pro.gif');
const ser = require('./../assets/models/ser.gif');
const thr = require('./../assets/models/thr.gif');
const trp = require('./../assets/models/trp.gif');
const tyr = require('./../assets/models/tyr.gif');
const val = require('./../assets/models/val.gif');


const model = [ala, arg, asn, asp, cys, gln, glu, gly, his, ile, leu, lys, met, phe, pro, ser, thr, trp, tyr, val]

export default function ModalTri({ route, navigation }: PropsStackModelTri) {


  const { aminoAcid } = route.params;
  const { name, info } = aminoacidos(aminoAcid)
  console.log("INFO", aminoAcid);

  return (
    <View style={stylesModal.container}>
      <Text style={stylesModal.name}>{name}</Text>
      <ModelTriAtom aminoAcid={aminoAcid} />
    </View>
  );
}


const stylesModal = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'space-between',
    padding: 15,
    borderRadius: 10,
    textAlign: 'center',
    backgroundColor: themePattern.mobile.bege
  },
  name: {
    textAlign: 'center',
    padding: 15,
    backgroundColor: themePattern.mobile.color1,
    fontSize: themePattern.mobile.title2,
    color: themePattern.mobile.white,
    fontWeight: 'bold',
    borderRadius: 10,
  }
});